var svHoverZoomBound = window.svHoverZoomBound || new WeakSet();
window.svHoverZoomBound = svHoverZoomBound;

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.image-magnify-hover').forEach(function(image) {
    var frame = image.closest('.product__media');
    var opener = image.closest('.product__modal-opener--image');
    if (!frame || !opener || svHoverZoomBound.has(image)) return;
    svHoverZoomBound.add(image);
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    function reset() {
      image.style.transform = '';
      image.style.transformOrigin = '';
      opener.classList.remove('sv-hover-zoom-active');
    }
    function move(event) {
      if (!canHover.matches) return;
      var rect = frame.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
      var y = Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100));
      image.style.transformOrigin = x + '% ' + y + '%';
      image.style.transform = 'scale(' + zoomRatio + ')';
      opener.classList.add('sv-hover-zoom-active');
    }
    opener.addEventListener('pointerenter', move);
    opener.addEventListener('pointermove', move);
    opener.addEventListener('pointerleave', reset);
    opener.addEventListener('pointercancel', reset);
    canHover.addEventListener('change', reset);
  });
}
enableZoomOnHover(2);
document.addEventListener('shopify:section:load', function() { enableZoomOnHover(2); });
